module.exports = __webpack_public_path__ + "static/media/jwt.9b721ad5.jpg";